module.exports = __webpack_public_path__ + "img/multi_agent_viewer.67bbc60e.png";